import FDPTrackers from 'fk-cp-common-components/fdpTracking/FDPTrackers';
import ApiCallerInterface from './ApiCallerInterface';
import UAHelper from 'fk-cp-shared/utils/UAHelper';
import IOSNativeCaller from 'fk-cp-shared/components/ios/NativeCaller';
import store from '../clientStore';
import MapiConfigProvider from 'fk-cp-shared/MapiConfigProvider';

let props = {
	store,
	apiCaller: ApiCallerInterface,
	platform: 'APP',
	UAHelper,
	IOSNativeCaller,
	configProvider: MapiConfigProvider
};

export default new FDPTrackers(props);
